import React from 'react';
import { cx } from '../../utils/cx.js';

/** Insights' shield marker for admin-only content. Named for screen readers, not only drawn. */
const AdminBadge = ({ className = '' }) => (
  <span
    className={cx('inline-flex flex-shrink-0 items-center', className)}
    title="Visible uniquement par les administrateurs"
  >
    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-brand-500" fill="currentColor" viewBox="0 0 24 24" aria-hidden>
      <path d="M12 2L4 6v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V6l-8-4z" />
      <text x="12.5" y="16" textAnchor="middle" fontSize="10" fontWeight="700" fill="#fff">A</text>
    </svg>
    <span className="sr-only">Admin</span>
  </span>
);

export default AdminBadge;
